<div *ngIf="model" [@loadedFadeAnimation]="'visible'" class="border-box-darkgrey p-xl-4">
  <h5>Os meus dados comerciais</h5>
  <hr>
  <div class="row">
    <div class="col-sm-2 col-xl-2 mb-2">
      <label>Código</label>
      <div class="form-control">{{model.Account}}</div>
    </div>
    <div class="col-sm-5 col-xl-7 mb-2">
      <label>Concessionário</label>
      <div class="form-control">{{model.Name}}</div>
    </div>
    <div class="col-sm-5 col-xl-3 mb-2">
      <label>NIF</label>
      <div class="form-control">{{model.Taxnumber1}}</div>
    </div>

    <div class="col-sm-6 col-xl-4 mb-2">
      <label>Nome comercial</label>
      <div class="form-control">{{model.ColloquialName}}</div>
    </div>
    <div class="col-sm-6 col-xl-6 mb-2">
      <label>Morada</label>
      <div class="form-control">{{model.Street}}</div>
    </div>
    <div class="col-sm-2 col-xl-2 mb-2">
      <label>Número</label>
      <div class="form-control adjust">{{model.HouseNo}}</div>
    </div>

    <div class="col-sm-2 col-xl-2 mb-2">
      <label>CÓDIGO POSTAL</label>
      <div class="form-control adjust">{{model.Zip}}</div>
    </div>
    <div class="col-sm-8 col-xl-5 mb-2">
      <label>Cidade</label>
      <div class="form-control">{{model.City}}</div>
    </div>
    <div class="col-sm-8 col-xl-5 mb-2">
      <label>Distrito</label>
      <div class="form-control">{{model.Region}}</div>
    </div>

    <div class="col-sm-4 col-xl-2 mb-2">
      <label>Telefone</label>
      <div class="form-control">{{model.BusinessPhone}}</div>
    </div>
    <div class="col-sm-4 col-xl-2 mb-2">
      <label>Telemóvel</label>
      <div class="form-control">{{model.MobilePhone}}</div>
    </div>
    <div class="col-sm-4 col-xl-2 mb-2">
      <label>Fax</label>
      <div class="form-control">{{model.Fax}}</div>
    </div>
    <div class="col-sm-4 col-xl-6 mb-2">
      <label>E-mail</label>
      <div class="form-control">{{model.Email}}</div>
    </div>
  </div>
  <form [formGroup]="dataform" (ngSubmit)="saveEvent()" class="">
    <div class="row mb-2">
      <div class="col-sm-6 col-xl-6 mb-3">
        <label>Website</label>
        <div class="form-control">{{model.Website}}</div>
      </div>
      <div class="col-sm-6 col-xl-6 mb-3">
        <label for="Slogan">Slogan</label>
        <input formControlName="Slogan" type="text" class="form-control" id="Slogan" placeholder="Slogan" [ngClass]="{'is-invalid':dataform.get('Slogan').invalid && (!dataform.get('Slogan').pristine || submitted == 1) , 'is-valid':dataform.get('Slogan').valid && !dataform.get('Slogan').pristine}">
        <div class="invalid-tooltip">
          <div [hidden]="!dataform.controls['Slogan'].errors || !dataform.controls['Slogan'].errors['required']">
            Campo obrigatório.
          </div>
          <div [hidden]="!dataform.controls['Slogan'].errors || !dataform.controls['Slogan'].errors['maxlength']">
            Limite de caracteres excedido.
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="mt-4">
      <div class="lead"><strong>Redes sociais</strong></div>
      <div class="row">
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="FacebookProfile">Facebook</label>
          <input formControlName="FacebookProfile" type="text" class="form-control" id="FacebookProfile" placeholder="Facebook" [ngClass]="{'is-invalid':dataform.get('FacebookProfile').invalid && (!dataform.get('FacebookProfile').pristine || submitted == 1) , 'is-valid':dataform.get('FacebookProfile').valid && !dataform.get('FacebookProfile').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['FacebookProfile'].errors || !dataform.controls['FacebookProfile'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>

        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="InstaProfile">Instagram</label>
          <input formControlName="InstaProfile" type="text" class="form-control" id="InstaProfile" placeholder="Instagram" [ngClass]="{'is-invalid':dataform.get('InstaProfile').invalid && (!dataform.get('InstaProfile').pristine || submitted == 1) , 'is-valid':dataform.get('InstaProfile').valid && !dataform.get('InstaProfile').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['InstaProfile'].errors || !dataform.controls['InstaProfile'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="TwitterProfile">Twitter</label>
          <input formControlName="TwitterProfile" type="text" class="form-control" id="TwitterProfile" placeholder="Twitter" [ngClass]="{'is-invalid':dataform.get('TwitterProfile').invalid && (!dataform.get('TwitterProfile').pristine || submitted == 1) , 'is-valid':dataform.get('TwitterProfile').valid && !dataform.get('TwitterProfile').pristine}">
          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['TwitterProfile'].errors || !dataform.controls['TwitterProfile'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="LinkedinProfile">Linkedin</label>
          <input formControlName="LinkedinProfile" type="text" class="form-control" id="LinkedinProfile" placeholder="Linkedin" [ngClass]="{'is-invalid':dataform.get('LinkedinProfile').invalid && (!dataform.get('LinkedinProfile').pristine || submitted == 1) , 'is-valid':dataform.get('LinkedinProfile').valid && !dataform.get('LinkedinProfile').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['LinkedinProfile'].errors || !dataform.controls['LinkedinProfile'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="YoutubeProfile">Youtube</label>
          <input formControlName="YoutubeProfile" type="text" class="form-control" id="YoutubeProfile" placeholder="Youtube" [ngClass]="{'is-invalid':dataform.get('YoutubeProfile').invalid && (!dataform.get('YoutubeProfile').pristine || submitted == 1) , 'is-valid':dataform.get('YoutubeProfile').valid && !dataform.get('YoutubeProfile').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['YoutubeProfile'].errors || !dataform.controls['YoutubeProfile'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
      </div>
      <hr>
      <div class="lead"><strong>Os meus dados bancários</strong></div>
      <div class="row">
        <div class="col-12 mb-3">
          <label for="BillingContact">Contacto / E-mail faturação</label>
          <input formControlName="BillingContact" type="text" class="form-control" id="BillingContact" placeholder="Contacto / E-mail faturação" [ngClass]="{'is-invalid':dataform.get('BillingContact').invalid && (!dataform.get('BillingContact').pristine || submitted == 1) , 'is-valid':dataform.get('BillingContact').valid && !dataform.get('BillingContact').pristine}">
          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['BillingContact'].errors || !dataform.controls['BillingContact'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['BillingContact'].errors || !dataform.controls['BillingContact'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <label for="BankingEntity">Instituição bancária</label>
          <input formControlName="BankingEntity" type="text" class="form-control" id="BankingEntity" placeholder="Instituição bancária" [ngClass]="{'is-invalid':dataform.get('BankingEntity').invalid && (!dataform.get('BankingEntity').pristine || submitted == 1) , 'is-valid':dataform.get('BankingEntity').valid && !dataform.get('BankingEntity').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['BankingEntity'].errors || !dataform.controls['BankingEntity'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['BankingEntity'].errors || !dataform.controls['BankingEntity'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <label for="AccountHolder">Titular da conta</label>
          <input formControlName="AccountHolder" type="text" class="form-control" id="AccountHolder" placeholder="Titular da conta" [ngClass]="{'is-invalid':dataform.get('AccountHolder').invalid && (!dataform.get('AccountHolder').pristine || submitted == 1) , 'is-valid':dataform.get('AccountHolder').valid && !dataform.get('AccountHolder').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AccountHolder'].errors || !dataform.controls['AccountHolder'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AccountHolder'].errors || !dataform.controls['AccountHolder'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-8 mb-3">
          <label for="TwitterProfile">Iban</label>
          <input formControlName="Iban" type="text" class="form-control" id="Iban" placeholder="Iban" [ngClass]="{'is-invalid':dataform.get('Iban').invalid && (!dataform.get('Iban').pristine || submitted == 1) , 'is-valid':dataform.get('Iban').valid && !dataform.get('Iban').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Iban'].errors || !dataform.controls['Iban'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Iban'].errors || !dataform.controls['Iban'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <label for="BicSwift">Código BIC/SWIFT</label>
          <input formControlName="BicSwift" type="text" class="form-control" id="BicSwift" placeholder="Código BIC/SWIFT" [ngClass]="{'is-invalid':dataform.get('BicSwift').invalid && (!dataform.get('BicSwift').pristine || submitted == 1) , 'is-valid':dataform.get('BicSwift').valid && !dataform.get('BicSwift').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['BicSwift'].errors || !dataform.controls['BicSwift'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['BicSwift'].errors || !dataform.controls['BicSwift'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="pt-3 pb-3">
      <div class="d-flex justify-content-end">
        <button *ngIf="canSave" type="submit" class="btn-orange"> GUARDAR</button>
      </div>
    </div>
  </form>
</div>